<template>
  <div>

    <button class="button is-small addDamageButton" title="Neu" v-on:click="openForm" v-show="!isCreating">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </button>
    
    <div v-show="isCreating">
        <div class='form'>
            <textarea v-model="damageText" type='text'></textarea>
            <button class="button is-small" v-on:click="sendForm()">
              <i class="fa fa-check"></i>
            </button>
            <button class='button is-small' v-on:click="closeForm">
              <i class="fa fa-close"></i>
            </button>
        </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      damageText: '',
      isCreating: false,
    };
  },
  methods: {
    openForm() {
	  	    
      this.isCreating = true;
      
    },
    closeForm() {
      this.isCreating = false;
    },
    sendForm() {
      if ( this.damageText.length > 0) {
        const damage = this.damageText;        
        this.$emit('create-damage', {
          damage,
        });
        this.damage = '';
        this.damageText = '';
        this.isCreating = false;
      }
    },
  },
};
</script>